<template>
  <b-modal
    ref="certificatesModal"
    hide-footer
    title="Certificates"
    centered
    lazy
    @hide="hideModal"
    @hidden="emitSelection"
    size="md"
  >
    <small v-html="modalDescription"></small>

    <div class="mt-3">
      <a href="#" class="card card-sm mb-2 certificate-option" @click.prevent="handleSelect('course')">
        <div class="card-body d-flex align-items-center">
          <md-icon class="text-primary mr-3" style="font-size: 32px;">school</md-icon>
          <div>
            <div class="font-weight-bold">Course Certificate</div>
            <small class="text-70">Completion of Classroom Training for a completed course.</small>
          </div>
        </div>
      </a>

      <a
        href="#"
        class="card card-sm mb-0 certificate-option"
        :class="{ 'certificate-option-disabled': !hasEnrolledProgram }"
        @click.prevent="handleSelect('program')"
      >
        <div class="card-body d-flex align-items-center">
          <md-icon class="text-primary mr-3" style="font-size: 32px;">receipt</md-icon>
          <div>
            <div class="font-weight-bold">Program Certificate</div>
            <small class="text-70" v-if="hasEnrolledProgram">
              Certificate of completion or enrollment for the student's program.
            </small>
            <small class="text-70" v-else>This student is not enrolled in a program.</small>
          </div>
        </div>
      </a>
    </div>
  </b-modal>
</template>

<script>
import { get, isEmpty } from 'lodash';

export default {
  name: 'CertificatesModal',
  props: {
    showModal: { type: Boolean, default: false },
    student: { type: Object, default: () => {} },
  },
  data() {
    return {
      selectedType: null,
    };
  },
  watch: {
    showModal(value) {
      if (value) {
        this.selectedType = null;
        this.$refs.certificatesModal.show();
      }
    },
  },
  computed: {
    hasEnrolledProgram() {
      return !isEmpty(get(this.student, 'enrolled_program'));
    },
    modalDescription() {
      if (!this.student) return '';
      return `Choose the certificate to generate for
        <b>${get(this.student, 'user.first_name', '')} ${get(this.student, 'user.last_name', '')}</b>.`;
    },
  },
  methods: {
    get,

    handleSelect(type) {
      if (type === 'program' && !this.hasEnrolledProgram) return;
      // The chosen certificate modal is opened only once this one is fully
      // closed, so the two modals never overlap.
      this.selectedType = type;
      this.$refs.certificatesModal.hide();
    },

    hideModal() {
      this.$emit('close', true);
    },

    emitSelection() {
      if (!this.selectedType) return;
      const type = this.selectedType;
      this.selectedType = null;
      this.$emit('select', type);
    },
  },
};
</script>

<style scoped>
.certificate-option {
  display: block;
  text-decoration: none;
  color: inherit;
}

.certificate-option:hover {
  border-color: #3b86f5;
}

.certificate-option-disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
